import { AuthContext } from '@core/shared';
import { OptionsApi } from '@core/swagger-client';
import { ContainerDefault, Heading } from '@core/ui';
import { Link } from '@online-webinar/router';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { UpNextWebinar } from '../../../../../webinar-management/src/components/organisms';
import { WebinarsListOnDemand, WebinarsListUpcoming } from '../../organisms';

export const OverviewWebinarsPage = () => {
    const { t } = useTranslation();

    const { isAuthenticated } = useContext(AuthContext);
    const { data: myUpcomingWebinars } = useSuspenseQuery(
        OptionsApi.webinars.getMyUpcomingOrNone(isAuthenticated, { refetchInterval: 60_000, staleTime: 60_000 })
    );
    return (
        <ContainerDefault>
            <div data-testid="webinarsList" className="max-w-300">
                <Heading variant="h1" classNames="mb-8 md:mb-10">
                    {t('Schedule.PageHeading')}
                </Heading>
                {!isAuthenticated && (
                    <p className="bg-info rounded-webinarsub text-center mt-2 mb-6 md:mb-8 p-4">
                        <Trans i18nKey="Schedule.LoginToSeeWebinars" components={{ a: <Link to="/login" className="link" /> }} />
                    </p>
                )}
                {myUpcomingWebinars.length > 0 && (
                    <div className="mb-12 md:mb-14">
                        <UpNextWebinar upcomingWebinar={myUpcomingWebinars[0]} />
                    </div>
                )}
                <Heading variant="h2" classNames="mb-6 md:mb-8">
                    {t('Pages.Organized.TabUpcoming')}
                </Heading>
                <WebinarsListUpcoming topN={5} />
                <Heading variant="h2" classNames="mt-16 mb-6 md:mb-8">
                    {t('Pages.Organized.TabOnDemand')}
                </Heading>
                <WebinarsListOnDemand topN={5} />
            </div>
        </ContainerDefault>
    );
};
